module.exports = __webpack_public_path__ + "img/trash.7e38b94c.svg";